export const VariantTypeCategoryFormStages = [
  {
    title: "Variant Type Category",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "g4b_name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
        ],
      },
    ],
  },
];
